import {Component, Input} from '@angular/core';

@Component({
	selector: 'dashboard-card',
	templateUrl: './dashboard-card.component.html'
})
export class DashboardCardWidget {
	@Input() title:string;
	@Input() icon:string;
	@Input() description:string;
	@Input('button-text') buttonText:string;
	@Input() link:string;
}



// WEBPACK FOOTER //
// ./src/app/components/widgets/dashboard/dashboard-card.component.ts